export default function (http) {
    return {
        query (data){
            return http.json({
                url: '/batch/record/query',
                data
            });
        },
        queryAudit (data){
            return http.json({
                url: '/batch/record/queryAudit',
                data
            });
        },
        audit (data){
            return http.json({
                url: '/batch/record/audit',
                data
            });
        },
        importExcel (data){
            return http.json({
                url: '/batch/record/importExcel',
                data
            });
        },
        save (data){
            return http.json({
                url: '/batch/record/save',
                data
            });
        },
        pass (data){
            return http.json({
                url: '/batch/record/pass',
                data
            });
        },
        fail (data){
            return http.json({
                url: '/batch/record/fail',
                data
            });
        },
        delete (data){
            return http.json({
                url: '/batch/record/delete',
                data
            });
        },

        gets (data){
            return http.json({
                url: `/batch/record/get?id=${data.id}`,
                data
            });
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/batchRecord.js